<label class="label" [attr.for]="for() || null">
  {{ label() }}
  @if (required()) {
    <sup class="required" label>*</sup>
  }
</label>

<ng-content />
